import React, { createContext, useReducer, useContext, useMemo } from 'react';

// ==================== 初始状态 ====================
const initialState = {
  type: '', // 默认选择产品类型
  loading: false, // 全局加载状态
  newsCache: {}, // 新闻数据缓存
  error: null, // 全局错误信息
  newsCurrentPage: 1, // 新闻当前页码
  queryResultStatus: false, // 查询结果显示状态
  click: '', // 点击事件
};

// ==================== Action Types ====================
export const ActionTypes = {
  SET_LOADING: 'SET_LOADING',
  SET_CACHE: 'SET_CACHE',
  SET_ERROR: 'SET_ERROR',
  CLEAR_ERROR: 'CLEAR_ERROR',
  SET_NEWS_CURRENT_PAGE: 'SET_NEWS_CURRENT_PAGE',
  SET_SERVICE_PAGE_TOP: 'SET_SERVICE_PAGE_TOP',
  SET_QUERY_RESULT_STATUS: 'SET_QUERY_RESULT_STATUS',
  SET_CLICK: 'SET_CLICK',
};

// ==================== Reducer 函数 ====================
const appReducer = (state, action) => {
  switch (action.type) {
    // 获取新闻页已选择的页码
    case ActionTypes.SET_NEWS_CURRENT_PAGE:
      return {
        ...state,
        newsCurrentPage: action.payload,
      };

    // 设置查询结果显示状态
    case ActionTypes.SET_QUERY_RESULT_STATUS:
      return {
        ...state,
        queryResultStatus: action.payload,
      };

    // 设置服务内容板块页面滚动
    case ActionTypes.SET_CLICK:
      return {
        ...state,
        click: action.payload,
      };

    // 设置加载状态
    case ActionTypes.SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    // 设置数据缓存
    case ActionTypes.SET_CACHE:
      return {
        ...state,
        productCache: action.payload.data,
      };

    // 设置错误信息
    case ActionTypes.SET_ERROR:
      return {
        ...state,
        error: action.payload,
      };

    // 清除错误信息
    case ActionTypes.CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };

    // 默认返回原状态
    default:
      return state;
  }
};

// ==================== 创建 Context ====================
const AppContext = createContext(null);

// ==================== Provider 组件 ====================
export const AppProvider = ({ children }) => {
  const [state, dispatch] = useReducer(appReducer, initialState);

  // 使用 useMemo 优化性能，避免不必要的重渲染
  const value = useMemo(() => ({ state, dispatch }), [state, dispatch]);

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

// ==================== 自定义 Hook ====================
export const useAppContext = () => {
  const context = useContext(AppContext);

  if (!context) {
    throw new Error('useAppContext must be used within AppProvider');
  }

  return context;
};
